// src/context/ThemeContext.jsx
import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    const themeStyles = {
        light: {
            background: '#E6F1FF',
            cardBackground: '#FFFFFF',
            sidebarBackgroundColor: '#0052B4',
            primaryColor: '#0052B4',
            text: '#424242',
            cardContentBackground: '#F0F7FF'
        },
        dark: {
            background: '#232323',
            cardBackground: '#383838',
            sidebarBackgroundColor: '#383838',
            primaryColor: '#0052B4',
            text: '#FFF',
            cardContentBackground: '#707071'
        },
    };

    return (
        <ThemeContext.Provider value={{ theme, themeStyles: themeStyles[theme], toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
